import React from 'react';
import {LoaderSection} from '../../loader/Loader';
import {WsChatMessage} from '../../../../types/message';
import {MessageItem} from './MessageItem';

type ChatMessagesProps = {
  userMsgIsLoading: boolean;
  storedMessage: WsChatMessage[];
  scrollToBottomRef: React.RefObject<HTMLDivElement>;
};

const ChatMessages = ({userMsgIsLoading, storedMessage, scrollToBottomRef}: ChatMessagesProps) => (
    <div className="card-body overflow-y-scroll me-n10"
         style={{maxHeight: "calc(100% - 150px)"}} id="kt_chat_messenger_body">
      <div ref={scrollToBottomRef} className="overflow-y-scroll scroll-y h-lg-auto pe-5" style={{maxHeight: "calc(100%)"}}
           data-kt-element="messages" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}"
           data-kt-scroll-max-height="auto"
           data-kt-scroll-dependencies="#kt_header, #kt_app_header, #kt_app_toolbar, #kt_toolbar, #kt_footer, #kt_app_footer, #kt_chat_messenger_header, #kt_chat_messenger_footer"
           data-kt-scroll-wrappers="#kt_content, #kt_app_content, #kt_chat_messenger_body" data-kt-scroll-offset="5px">
        {userMsgIsLoading ? (
            <LoaderSection height={"30vh"}/>
        ) : (
            storedMessage?.map((msg: WsChatMessage) => (
                <div key={msg.message_id}>
                  <MessageItem message={msg}/>
                </div>
            ))
        )}
      </div>
    </div>
);

export default ChatMessages;